import { Steps, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DealerInfoStep from "../../components/newOrderRequest/dealerInfoStep";
import AddressStep from "../../components/newOrderRequest/addressStep";
import OrderDetailStep from "../../components/newOrderRequest/orderDetailStep";
import ProductAndPayment from "../../components/newOrderRequest/productAndPayment";
import { SaveDraft } from "../../../redux/actions/adminActions/newOrderRequestAction";
import Alertify from "../../../services/alertify";
import { getQueryParams } from "../../../utilities/getQueryParams";
import {
  CloneOrderAPI,
  DraftOrderDetailsAPI,
} from "../../../redux/actions/adminActions/orderDetailsAction";
import { DealerDetails } from "../../../redux/actions/adminActions/adminDealersActions";

const { Title } = Typography;
const NewOrderRequest = () => {
  const dealerCodes = useSelector((state) => state.admin_dealers);
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [headerOrderType, setHeaderOrderType] = useState("");
  const dispatch = useDispatch();
  const [uuid, setUuid] = useState();
  const [orderId, setOrderId] = useState();
  const params = getQueryParams();
  const uuIds = params.UUID;
  const orderIds = params.orderId;
  const [loading, setLoading] = useState(false);
  const [dealerChangeCount, setDealerChangeCount] = useState(0);
  const [requestId, setRequestId] = useState();
  useEffect(() => {
    setUuid(uuIds);
    setOrderId(orderIds);
    if (uuIds) {
      setLoading(true);
      const data = {
        uuid: uuIds,
      };
      setUuid(uuIds);
      dispatch(DraftOrderDetailsAPI(data))
        .then((response) => {
          const formData = response.payload.data.data.details;
          setFormData(formData);
          setRequestId(formData.requestId);
          const data2 = {
            dealer_code: formData.dealer_code,
          };
          dispatch(DealerDetails(data2))
            .then((response) => {
              const dealerDetails = response.payload?.data?.data;
              // console.log("dealerDetails------------", dealerDetails);
            })
            .catch((error) => {
              Alertify.error(
                "Failed to fetch Dealer Details: " + error.message,
              );
            });
          // for current Step
          const progress = response.payload.data.data.progress;
          if (progress.step1 === "completed") {
            setCurrentStep(1);
          } else if (progress.step2 === "completed") {
            setCurrentStep(2);
          } else if (progress.step3 === "completed") {
            setCurrentStep(3);
          } else if (progress.step4 === "completed") {
            setCurrentStep(3);
          } else {
            setCurrentStep(0);
          }
          setLoading(false);
        })
        .catch((error) => {
          Alertify.error(
            "Failed to fetch Draft Order Details: " + error.message,
          );
          setLoading(false);
        });
    } else if (orderIds) {
      setLoading(true);

      const data = {
        order_id: orderIds,
      };
      setOrderId(orderIds);
      dispatch(CloneOrderAPI(data))
        .then((response) => {
          const formData = response.payload.data.data;
          setFormData(formData); // Update formData here
          // console.log("The Form Data for Clone Order is::::::::", response);

          // get shipping details on the basis of dealer code
          const data2 = {
            dealer_code: formData.dealer_code,
          };
          dispatch(DealerDetails(data2))
            .then((response) => {
              const dealerDetails = response.payload?.data?.data;
              // console.log("dealerDetails------------", dealerDetails);
            })
            .catch((error) => {
              Alertify.error(
                "Failed to fetch Dealer Details: " + error.message,
              );
            });
          setLoading(false);
        })
        .catch((error) => {
          Alertify.error(
            "Failed to fetch Draft Order Details: " + error.message,
          );
          setLoading(false);
        });
    }
  }, [uuIds, orderIds, dispatch]);

  const handleNext = (stepData) => {
    setFormData((prevFormData) => {
      let updatedFormData = {
        ...prevFormData,
        ...stepData,
        requestId: requestId || null,
      };

      // Filter out invalid products
      if (Array.isArray(updatedFormData.products)) {
        updatedFormData.products = updatedFormData.products.filter(
          (product) => {
            // Remove product if any value is NaN, "NaN", or undefined (except pad can be "0.00000")
            return Object.entries(product).every(([key, value]) => {
              if (key === "pad") return true; // allow pad to be "0.00000"
              if (value === undefined) return false;
              if (typeof value === "number" && isNaN(value)) return false;
              if (value === "NaN") return false;
              return true;
            });
          },
        );
      }

      // console.log("Updated Form Data is: ", updatedFormData);
      if (currentStep <= 3) {
        setCurrentStep((prevStep) => prevStep + 1);
        // console.log("Current step is:=========================", currentStep);
      }
      const draftData = {
        details: updatedFormData,
        uuid: uuid,
        progress: {
          step1: currentStep === 0 ? "completed" : "",
          step2: currentStep === 1 ? "completed" : "",
          step3: currentStep === 2 ? "completed" : "",
          step4: currentStep === 3 ? "completed" : "",
        },
      };
      dispatch(SaveDraft(draftData))
        .then((response) => {
          setUuid(response.payload.data.data.uuid);
          if (!params.UUID) {
            const currentUrl = window.location.pathname;
            const newUrl = `${currentUrl}?UUID=${response.payload.data.data.uuid}`;
            window.history.replaceState(null, "", newUrl);
          }
          // console.log("Draft response is:", formData);
          setFormData(response?.payload?.data?.data?.details);
          // console.log("dsffffffffff", response?.payload?.data?.data?.details);
          Alertify.success("Order draft saved successfully!");
        })
        .catch((error) => {
          Alertify.error("Failed to save draft: " + error.message);
        });

      return updatedFormData; // Ensure updatedFormData is returned
    });
  };

  const handlePrev = (stepData) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, ...stepData };
      // console.log("Updated Form Data is: ", updatedFormData);
      if (currentStep >= 0) {
        setCurrentStep((prevStep) => prevStep - 1);
      }
      return updatedFormData;
    });
  };

  return (
    <>
      <Title level={2} className="text-left">
        {headerOrderType ? headerOrderType : formData?.orderType || "Order"}{" "}
        Request
      </Title>
      <Steps
        progressDot
        current={currentStep}
        items={[
          {
            title: "Dealer Info",
          },
          {
            title: "Addresses",
          },
          {
            title: "Order Details",
          },
          {
            title: "Product & Payment Details",
          },
        ]}
      />
      {/* {loading ? (
        <div className="flex items-center justify-center pt-60">
          <LoaderIcon className="w-[3vw] h-[3vw] " />
        </div>
      ) : ( */}
      <div className="steps-content">
        {currentStep === 0 && (
          <DealerInfoStep
            uuid={uuid}
            setHeaderOrderType={setHeaderOrderType}
            dealerChangeCount={dealerChangeCount}
            setDealerChangeCount={setDealerChangeCount}
            onNext={handleNext}
            dealerCodes={dealerCodes}
            currentStep={currentStep}
            handlePrev={handlePrev}
            handleNext={handleNext}
            formData={formData}
          />
        )}
        {currentStep === 1 && (
          <AddressStep
            uuid={uuid}
            onNext={handleNext}
            dealerCode={formData.dealer_code}
            shipAddresses={formData.shipAddresses}
            currentStep={currentStep}
            handlePrev={handlePrev}
            handleNext={handleNext}
            formData={formData}
          />
        )}
        {currentStep === 2 && (
          <OrderDetailStep
            uuid={uuid}
            onNext={handleNext}
            currentStep={currentStep}
            handlePrev={handlePrev}
            handleNext={handleNext}
            formData={formData}
          />
        )}
        {currentStep === 3 && (
          <ProductAndPayment
            onNext={handleNext}
            uuid={uuid}
            dealerCodes={dealerCodes}
            currentStep={currentStep}
            handlePrev={handlePrev}
            handleNext={handleNext}
            formData={formData}
            setFormData={setFormData}
            requestId={requestId}
          />
        )}
      </div>
      {/* )} */}
    </>
  );
};

export default NewOrderRequest;
